import { render, staticRenderFns } from "./navBox.vue?vue&type=template&id=db7d84d4&scoped=true"
import script from "./navBox.vue?vue&type=script&lang=js"
export * from "./navBox.vue?vue&type=script&lang=js"
import style0 from "./navBox.vue?vue&type=style&index=0&id=db7d84d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db7d84d4",
  null
  
)

export default component.exports